/**
 * helper that defines if the status code is a successful one
 */
export const isSuccessStatusCode = (statusCode: any): boolean => {
    if(typeof statusCode === "number") {
        return statusCode >= 200 && statusCode < 300;
    } 
    return false;
};

/**
 * helper that defines if the status code is an error one
 */
export const isClientErrorStatusCode = (statusCode: any): boolean => {
    if(typeof statusCode === "number") {
        return statusCode >= 400 && statusCode < 500;
    } 
    return false;
};

/**
 * helper that defines if the status code is a server error one
 */
export const isServerErrorStatusCode = (statusCode: any): boolean => {
    if(typeof statusCode === "number") {
        return statusCode >= 500 && statusCode < 600;
    } 
    return false;
};
